import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/'
import i18n from '@/locales'
import { segmentPage } from '@/analytics/segment'
import login from '@/modules/login/_router/'
import dashboard from '@/modules/dashboard/_router/'
import benefits from '@/modules/benefits/_router/'
import budgets from '@/modules/budgets/_router/'
import { teamCards, myCards } from '@/modules/cards/_router/'
import company from '@/modules/company/_router/'
import customers from '@/modules/customers/_router/'
import merchants from '@/modules/merchants/_router/'
import exportData from '@/modules/export/_router/'
import logs from '@/modules/logs/_router/'
import users from '@/modules/users/_router/'
import {
  expenses,
  transactions,
  reimbursements,
  detailTransactions
} from '@/modules/transactions/_router/'
import jwtDecode from 'jwt-decode'

const router = new VueRouter({
  mode: 'history',
  routes: [
    ...login,
    ...dashboard,
    ...benefits,
    ...budgets,
    ...teamCards,
    ...myCards,
    ...company,
    ...customers,
    ...merchants,
    ...logs,
    ...users,
    ...expenses,
    ...transactions,
    ...reimbursements,
    ...detailTransactions,
    ...exportData,
    {
      path: '*',
      redirect: '/dashboard'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.name === 'customer-signup') {
    window.location.href = 'https://getfuell.com'
  }
  let userToken = localStorage.getItem('token')
  if (userToken) {
    await store.dispatch('LoginStore/tryAutoLogin')
    if (to.meta.isPublic && to.name !== 'resetpasscode') {
      await store.dispatch('LoginStore/logout', { redirect: false })
    }

    // const userRoles = jwtDecode(userToken).roles
    const userRoles = store.getters['LoginStore/loggedUserRoles']
    const { allowedRoles } = to.meta
    if (allowedRoles && allowedRoles.length > 0 && userRoles) {
      const userAllowedInRoute = allowedRoles.some((el) =>
        userRoles.includes(el)
      )

      if (
        !userAllowedInRoute &&
        !to.query.supplanting &&
        !to.path.includes('customers')
      ) {
        store.dispatch(
          'SnackBars/addError',
          i18n.t('route_redirection_role_notification')
        )
        segmentPage(to)
        next({ name: 'dashboard' })
      }
    }

    if (localStorage.getItem('token')) {
      if (!store.getters['LoginStore/isImpersonating']) {
        const { id: currentOfficeId } =
          store.getters['CompanyStore/currentCompany']
        let token = localStorage.getItem('token')
        let user = jwtDecode(token)
        let companyId = user.office_id
        if (
          !currentOfficeId &&
          !userRoles.includes('ROLE_SUPER_ADMIN') &&
          !userRoles.includes('ROLE_SUPER_BOOKKEEPER') &&
          !userRoles.includes('ROLE_COMMERCIAL')
        ) {
          await store.dispatch('CompanyStore/fetchCompany', companyId)
        }
      }
      if (!store.getters['GlobalStore/initializedData']) {
        store.dispatch('GlobalStore/initializeData')
      }
    }

    segmentPage(to)
    next()
  } else {
    if (to.meta.isPublic) {
      segmentPage(to)
      next()
    } else {
      if (to.name === 'resetpasscode') {
        next()
      }

      next({ name: 'login' })
    }
  }
})

export default router

const methods = ['push', 'replace']
methods.forEach(method => {
  const originalMethod = VueRouter.prototype[method]
  VueRouter.prototype[method] = function m (location) {
    return originalMethod.call(this, location).catch(error => {
      if (error.name !== 'NavigationDuplicated') {
        throw error
      }
    })
  }
})
Vue.use(VueRouter)

/*
  await store.dispatch('LoginStore/tryAutoLogin', { to, from, next })

  const { allowedRoles, isPublic } = to.meta

  if (to.meta.layout) {
    store.commit('LayoutStore/setLayout', to.meta.layout)
  } else {
    store.commit('LayoutStore/resetLayout')
  }

  if (isPublic && to.name !== 'login') {
    store.dispatch('LoginStore/clearAuthData')
    next()
    return
  }
  let token = localStorage.getItem('token')
  let currentUserRole = false
  if (token) {
    currentUserRole = jwtDecode(token).roles[0]
  }

  if (allowedRoles && allowedRoles.length > 0 && currentUserRole) {
    const userAllowedInRoute = allowedRoles.includes(currentUserRole)

    if (userAllowedInRoute) {
      next()
      return
    } else {
      store.dispatch(
        'SnackBars/addError',
        i18n.t('route_redirection_role_notification')
      )
      next({ name: 'dashboard' })
      return
    }
  }

  // Segment page track
  segmentPage(to.path)
  next()
})
*/
